import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa'
import Select from 'react-select';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';

const AddMember = ({ setLoading, userData }) => {
  const [memberType, setMemberType] = useState('');
  const [teachers, setTeachers] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [students, setStudents] = useState([]);

  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [selectedAY, setSelectedAY] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
const [memberIdInput, setMemberIdInput] = useState('');
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [members, setMembers] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [selectedMember, setSelectedMember] = useState('');
const [showDelete, setShowDelete] = useState(false);



  // Fetch teachers
  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-employee');
      if (response.ok) {
        const data = await response.json();
        // Filter teachers excluding current user
        const filteredTeachers = data.filter(emp => emp.id !== userData.id && emp.role === 'Teacher');
        // Map for react-select
        const options = filteredTeachers.map(t => ({
          value: t.id,
          label: t.name || t.fullName || t.username || `Teacher ${t.id}`,
        }));
        setTeachers(options);
      } else {
        console.error('Failed to fetch teachers');
      }
    } catch (error) {
      console.error('Error fetching teachers:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch academic years
  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        // Assuming API returns array of { id, name } or similar
const options = data.map(ay => ({
  value: ay.year,
  label: ay.title || ay.year || `AY ${ay.id}`,
}));
        setAcademicYears(options);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching academic years:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        // Map classes to react-select options
        const options = data.map(cls => ({
          value: cls.id,
          label: cls.class_name,
          sections: cls.sections,
        }));
        setClasses(options);
      } else {
        console.error('Failed to fetch classes');
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
    } finally {
      setLoading(false);
    }
  };

  // When class changes, update sections
  useEffect(() => {
    if (selectedClass) {
      const cls = classes.find(c => c.value === selectedClass.value);
      if (cls && cls.sections) {
        const sectionsArr = cls.sections.split(',').map(s => s.trim()).filter(Boolean);
        const sectionOptions = sectionsArr.map(s => ({ value: s, label: s }));
        setAvailableSections(sectionOptions);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection(null);
    } else {
      setAvailableSections([]);
      setSelectedSection(null);
    }
  }, [selectedClass, classes]);


  useEffect(() => {
    const fetchStudents = async () => {
 if (!selectedAY || !selectedClass || !selectedSection) {
      setStudents([]);
      return;
    }
    
    setLoading(true);
   
    try {
        const params = new URLSearchParams();
        params.append('ay', selectedAY.value);
        params.append('class_name', selectedClass.label);
          params.append('section', selectedSection.value);
          console.log(selectedAY, selectedClass.label, selectedSection.value);

          const url = `https://api.kcian.in/get-student?${params.toString()}`;
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          // Map students for react-select
          const options = data.map(std => ({
            value: std.id,
            label: std.name || `Student ${std.id}`,
          }));
          setStudents(options);
        } else {
          console.error('Failed to fetch students');
        }
      } catch (error) {
        console.error('Error fetching students:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [selectedAY, selectedClass, selectedSection]);

  // On member type change, fetch relevant data
  useEffect(() => {
    setSelectedTeacher(null);
    setSelectedAY(null);
    setSelectedClass(null);
    setSelectedSection(null);
    setSelectedStudent(null);
    setTeachers([]);
    setAcademicYears([]);
    setClasses([]);
    setAvailableSections([]);
    setStudents([]);

    if (memberType === 'Teacher') {
      fetchTeachers();
    } else if (memberType === 'Student') {
      fetchAcademicYears();
      fetchClasses();
    }
  }, [memberType]);

  const handleMemberTypeChange = e => {
    setMemberType(e.target.value);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  let selectedMember = null;

  if (memberType === 'Teacher') {
    if (!selectedTeacher) {
      alert('Please select a teacher');
      return;
    }
    selectedMember = selectedTeacher;
  } else if (memberType === 'Student') {
    if (!selectedStudent) {
      alert('Please select a student');
      return;
    }
    selectedMember = selectedStudent;
  } else {
    alert('Please select member type');
    return;
  }


  const payload = {
    member_type: memberType,
    name: selectedMember.label,
    member_id: memberIdInput.trim(),
    org_id: selectedMember.value,
  };

  
  try {
    setLoading(true);
    const response = await fetch('https://api.kcian.in/libadd-member', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
              setResponse2({ message: 'Member Added Successfully!', status: 'success' });
fetchMember();
      // Reset form or do other logic here
      setMemberType('');
      setSelectedTeacher(null);
      setSelectedAY(null);
      setSelectedClass(null);
      setSelectedSection(null);
      setSelectedStudent(null);
      setMemberIdInput('');
      setTeachers([]);
      setAcademicYears([]);
      setClasses([]);
      setAvailableSections([]);
      setStudents([]);
    } else {
      const errorData = await response.json();
                setResponse2({ message: errorData.message || 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
        setTimeout(() => {
          setResponse2('');
        }, 2000);     }
};


               const fetchMember = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-member');
        
                        if (response.ok) {
                            const data = await response.json();
                            setMembers(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


         useEffect(() => {
      fetchMember();
    }, []);

      const filteredMember = members.filter(m => {
  const term = searchTerm.toLowerCase();
  return (
    m.member_type.toLowerCase().includes(term) ||
    m.name.toLowerCase().includes(term) ||
    m.member_id.toLowerCase().includes(term)
  );
});


    const handleShowDelete = (book) => {
    setSelectedMember(book);
    setShowDelete(true);
  }


                const handleDelete = async (bId) => {
    try {
      const response = await fetch(`https://api.kcian.in/libdelete-member/${bId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setMembers((prevData) => prevData.filter((product) => product.id !== bId));
        setShowDelete(false);
        setResponse2({ message: 'Member Removed from Library!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting:', error);
    }
  };

  return (
    <>
    <section className='py-4'>
      <div className='px-4'>
        <HeadingArea message1='Library' message2='Add Member' />

        <div className='row'>

          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <div className="profile-card">
              <p className="profile-heading">Add Member</p>
              <form className='mt-4' onSubmit={handleSubmit}>

                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Member Type*</label>
                  <select
                    name='memberType'
                    value={memberType}
                    onChange={handleMemberTypeChange}
                    className='profile-input'
                    required
                  >
                    <option value=''>Select Member Type..</option>
                    <option value='Student'>Student</option>
                    <option value='Teacher'>Teacher</option>
                  </select>
                </div>

                {memberType === 'Teacher' && (
                  <div className='profile-input-area mb-4 border-0'>
                    <label className='profile-badge'>Select Teacher*</label>
                    <Select
                      options={teachers}
                      value={selectedTeacher}
                      className='profile-input'
                      onChange={setSelectedTeacher}
                      placeholder="Search and select teacher..."
                      isClearable
                    />
                  </div>
                )}

                {memberType === 'Student' && (
                  <>
                    <div className='profile-input-area mb-4 border-0'>
                      <label className='profile-badge'>Academic Year*</label>
                      <Select
                        options={academicYears}
                        value={selectedAY}
                      className='profile-input'
                        onChange={setSelectedAY}
                        placeholder="Select Academic Year"
                        isClearable
                      />
                    </div>

                    <div className='profile-input-area mb-4 border-0'>
                      <label className='profile-badge'>Class*</label>
                      <Select
                        options={classes}
                        value={selectedClass}
                        onChange={setSelectedClass}
                        className='profile-input'
                        placeholder="Select Class"
                        isClearable
                      />
                    </div>

                    <div className='profile-input-area mb-4 border-0'>
                      <label className='profile-badge'>Section*</label>
                      <Select
                        options={availableSections}
                        value={selectedSection}
                        onChange={setSelectedSection}
                        className='profile-input'
                        placeholder="Select Section"
                        isClearable
                        isDisabled={!availableSections.length}
                      />
                    </div>

                    <div className='profile-input-area mb-4 border-0'>
                      <label className='profile-badge'>Select Student*</label>
                      <Select
                        options={students}
                        value={selectedStudent}
                        onChange={setSelectedStudent}
                        className='profile-input'
                        placeholder="Select student..."
                        isClearable
                        isDisabled={!students.length}
                      />
                    </div>
                  </>
                )}


                <div className='profile-input-area mb-4'>
  <label className='profile-badge'>Member ID*</label>
  <input
    type='text'
    className='profile-input'
    value={memberIdInput}
    onChange={e => setMemberIdInput(e.target.value)}
    placeholder="Enter Member ID"
    required
  />
</div>


                <div className='text-center'>
                  <button type='submit' className='profile-btn'>
                    <FaCheck /> Save
                  </button>
                </div>

              </form>
            </div>
          </div>


                    <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                        <div className='profile-card'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                <span className="profile-heading align-content-center">Member List</span>

                                <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                    <input
                                        type='text'
                                        name='search'
                                        className='profile-input border-bottom rounded-0'
                                        placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>


                            <div className='table-responsive'>
                                <table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>S No</th>
                                        <th>Name</th>
                                        <th>Member Id</th>
                                        <th>Type</th>
                                                                                <th>User Id</th>
                                        <th>Member Designation</th>
                                        <th>AY</th>
                                        <th>Class</th>
                                        <th className='rounded-end-4'>Activity</th>
                                    </thead>

    {filteredMember.map((mem, index) => (
      <tr className='account-tr' key={mem.id}>
        <td>{index + 1}</td>
        <td>{mem.member_name || '--'}</td>
        <td>{mem.member_id || '--'}</td>
        <td>{mem.member_type}</td>
        <td>{mem.member_regno || '--'}</td>
        <td>{mem.member_des || '--'}</td>
        <td>{mem.member_ay || ''}</td>
        <td>{mem.member_class || ''} {mem.member_section || ''}</td>
        <td>
          <RiDeleteBin6Line className='account-icon1' onClick={() => handleShowDelete(mem)} />
        </td>
      </tr>
    ))}


                                </table>
                            </div>

                        </div>
                    </div>

        </div>
      </div>
    </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Member!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
      <th className='rounded-start-4'>Name</th>
                                        <th>Member Id</th>
                                        <th>Type</th>
                                                                                <th>User Id</th>
                                        <th>Member Designation</th>
                                        <th>AY</th>
      <th className='rounded-end-4'>Class</th>
</thead>


<tr className='account-tr'>
        <td>{selectedMember.member_name}</td>
        <td>{selectedMember.member_id}</td>
        <td>{selectedMember.member_type}</td>
        <td>{selectedMember.member_regno || '--'}</td>
        <td>{selectedMember.member_des || '--'}</td>
        <td>{selectedMember.member_ay || ''}</td>
        <td>{selectedMember.member_class || ''} {selectedMember.member_section || ''}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Book will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedMember.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

</>
  )
}

export default AddMember;




